import React, { Component } from 'react'
import Sortable, { sortable } from 'react-anything-sortable'
import 'react-anything-sortable/sortable.css'

import './SortableList.css'

export default class SortableList extends Component {
  renderItem = (item, index) => {
    const { renderItem } = this.props
    return (
      <SortableItem key={index} sortData={item} style={{ width: '100%' }}>
        {renderItem(item, index)}
      </SortableItem>
    )
  }
  render () {
    const { items, onSort, sortHandle } = this.props
    return (
      <Sortable dynamic onSort={onSort} sortHandle={sortHandle}>
        {items.map(this.renderItem)}
      </Sortable>
    )
  }
}

const Item = ({ className, style, onMouseDown, onTouchStart, children }) => (
  <div
    className={className}
    style={style}
    onMouseDown={onMouseDown}
    onTouchStart={onTouchStart}>
    {children}
  </div>
)

const SortableItem = sortable(Item)



// WEBPACK FOOTER //
// ./src/components/playlist/SortableList.js